export enum DemandBannerLocation {
  REALTOR_DEMAND_BUTTON = 'MagazineForumRieltorovButton',
  LISTING_BANNER = 'MagazineForumRieltorovListing',
  ADD_QUESTION = 'MagazineAddVopros',
  POPUP = 'MagazineForumRieltorovPopup',
}
